import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg'

import { IconProps } from '..'

const InProgress = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 28 28"
    fill="none"
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        d="M14 27a12.915 12.915 0 0 1-9.192-3.808A12.915 12.915 0 0 1 1 14c0-3.472 1.352-6.737 3.808-9.192A12.915 12.915 0 0 1 14 1c3.472 0 6.737 1.352 9.192 3.808A12.915 12.915 0 0 1 27 14c0 3.472-1.352 6.737-3.808 9.192A12.915 12.915 0 0 1 14 27Z"
        fill="#54A0FF"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.89 19.942a12.915 12.915 0 0 0 9.193 3.808c3.473 0 6.737-1.352 9.193-3.808a13.023 13.023 0 0 0 2.493-3.48 12.908 12.908 0 0 1-3.577 6.73A12.915 12.915 0 0 1 14 27a12.915 12.915 0 0 1-9.192-3.808A12.915 12.915 0 0 1 1 14c0-2.013.454-3.956 1.315-5.712a13.14 13.14 0 0 0-.232 2.462c0 3.472 1.353 6.737 3.808 9.192Z"
        fill="#3A74BB"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.863 4.265a9.893 9.893 0 0 1 2.274 0 .8.8 0 0 1-.184 1.59 8.295 8.295 0 0 0-1.907 0 .8.8 0 1 1-.183-1.59Zm3.968 1.152A.8.8 0 0 1 17.883 5a9.79 9.79 0 0 1 1.97 1.139.8.8 0 0 1-.957 1.283 8.192 8.192 0 0 0-1.648-.954.8.8 0 0 1-.417-1.051Zm-5.662 0a.8.8 0 0 1-.418 1.051 8.19 8.19 0 0 0-1.647.954.8.8 0 0 1-.957-1.283 9.79 9.79 0 0 1 1.97-1.14.8.8 0 0 1 1.052.418Zm-3.91 2.567a.8.8 0 0 1 .163 1.12 8.19 8.19 0 0 0-.954 1.648A.8.8 0 1 1 5 10.117a9.79 9.79 0 0 1 1.14-1.97.8.8 0 0 1 1.12-.163Zm13.482 0a.8.8 0 0 1 1.12.163 9.789 9.789 0 0 1 1.14 1.97.8.8 0 0 1-1.47.635 8.196 8.196 0 0 0-.953-1.648.8.8 0 0 1 .163-1.12ZM5.151 12.16a.8.8 0 0 1 .704.886 8.296 8.296 0 0 0 0 1.908.8.8 0 0 1-1.59.183 9.895 9.895 0 0 1 0-2.274.8.8 0 0 1 .887-.703Zm17.697 0a.8.8 0 0 1 .887.703 9.895 9.895 0 0 1 0 2.274.8.8 0 0 1-1.59-.184 8.307 8.307 0 0 0 0-1.906.8.8 0 0 1 .703-.887ZM5.417 16.83a.8.8 0 0 1 1.051.417 8.19 8.19 0 0 0 .954 1.648.8.8 0 0 1-1.283.957 9.791 9.791 0 0 1-1.14-1.97.8.8 0 0 1 .418-1.052Zm17.166 0A.8.8 0 0 1 23 17.883a9.79 9.79 0 0 1-1.14 1.97.8.8 0 1 1-1.282-.957c.379-.507.7-1.06.954-1.648a.8.8 0 0 1 1.051-.417Zm-14.599 3.91a.8.8 0 0 1 1.12-.163c.507.379 1.06.7 1.648.954A.8.8 0 0 1 10.117 23a9.797 9.797 0 0 1-1.97-1.139.8.8 0 0 1-.163-1.12Zm12.032 0a.8.8 0 0 1-.163 1.12 9.796 9.796 0 0 1-1.97 1.14.8.8 0 1 1-.635-1.47 8.188 8.188 0 0 0 1.648-.953.8.8 0 0 1 1.12.163Zm-7.856 2.107a.8.8 0 0 1 .886-.703 8.286 8.286 0 0 0 1.908 0 .8.8 0 0 1 .183 1.59 9.893 9.893 0 0 1-2.274 0 .8.8 0 0 1-.703-.887Z"
        fill="#A6FF70"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.2 14A8.2 8.2 0 0 0 14 5.8V4.2c5.412 0 9.8 4.388 9.8 9.8 0 5.412-4.388 9.8-9.8 9.8-5.412 0-9.8-4.388-9.8-9.8h1.6a8.2 8.2 0 0 0 16.4 0Z"
        fill="#A0FF66"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.207 10.293a1 1 0 0 1 0 1.414l-6 6a1 1 0 0 1-1.414 0l-2.5-2.5a1 1 0 1 1 1.414-1.414l1.793 1.793 5.293-5.293a1 1 0 0 1 1.414 0Z"
        fill="#A6FF70"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" transform="translate(1 1)" d="M0 0h26v26H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default InProgress
